export default __webpack_public_path__ + "static/media/Skirmisher's Arrows.ea452c6e.jpg";